import type { FunctionComponent } from "react";
import Highlighter from "react-highlight-words";
import { HIGHLIGHT_PROPS } from "components/job/JobTable/JobBankDetails/constants";
import type { BankDetails } from "components/job/JobTable/JobBankDetails/types";
import useJobBankDetailsProps from "components/job/JobTable/JobBankDetails/useJobBankDetailsProps";

export interface JobBankDetailsProps {
  bankDetails: BankDetails;
}

const JobBankDetails: FunctionComponent<JobBankDetailsProps> = function ({
  bankDetails,
}) {
  const { searchWords, name, number, sortCode } =
    useJobBankDetailsProps(bankDetails);

  return (
    <div className="flex flex-col text-12-18">
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords}
        textToHighlight={name || ""}
        className="text-12-18-em"
      />
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords}
        textToHighlight={number || ""}
        className="text-12-18-em"
      />
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords}
        textToHighlight={sortCode || ""}
        className="text-12-18-em"
      />
    </div>
  );
};

export default JobBankDetails;
